import React = require("react");
import i18next from 'i18next';
import { DependencyData, FieldData, StepData } from "../../../form/types";
import moment from "moment"
import { Answer } from "../../../../generated_models";
import { getSupplierData, getSupplierLMSData } from "./beslismatrixWizardApi";

export let getStep3Data = (): StepData[] => {

    let supplierList: string[] = getSupplierData()
    let supplierLMSList: string[] = getSupplierLMSData()

    let q3: string[] = [
        'Minder dan 1 jaar',
        'Tussen 1 jaar en 2 jaar',
        'Langer dan 2 jaar',
        'Ik weet het niet'
    ]

    let mk_q1 = () => {
        let fieldId: number = 8
        let fieldAnswers: Answer[] = supplierList.map((a, i) => ({ Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "" }))
        let fieldData: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Dropdown", itemOrderNumber: 1, description: "", optionalDefaultValue: "", sourceName: "",
                title: i18next.t('Tab3.Q1'), useExternalSource: false, width_percentage: "Large", label: 'Tab3.Q1'
            },
            maybe_answers: fieldAnswers,
            maybe_labels: [],
            user_input: undefined
        }
        return fieldData
    }
    let f1 = mk_q1()

    let mk_q2 = () => {
        let fieldId: number = 9
        let fieldAnswers: Answer[] = supplierLMSList.map((a, i) => ({ Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "" }))
        let fieldData: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Dropdown", itemOrderNumber: 2, description: "", optionalDefaultValue: "", sourceName: "",
                title: i18next.t('Tab3.Q2'), useExternalSource: false, width_percentage: "Large", label: 'Tab3.Q2'
            },
            maybe_answers: fieldAnswers,
            maybe_labels: [],
            user_input: undefined
        }
        return fieldData
    }
    let f2 = mk_q2()

    let mk_q3 = () => {
        let fieldId: number = 10
        let fieldAnswers: Answer[] = q3.map((a, i) => ({ Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "" }))
        let fieldData: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Dropdown", itemOrderNumber: 3, description: "", optionalDefaultValue: "", sourceName: "",
                title: i18next.t('Tab3.Q3'), useExternalSource: false, width_percentage: "Large", label: 'Tab3.Q3'
            },
            maybe_answers: fieldAnswers,
            maybe_labels: [],
            user_input: undefined
        }
        return fieldData
    }
    let f3 = mk_q3()

    let field_list: FieldData[] = [f1, f2, f3]

    let mk_dependency_filled = () => {
        let dependency_filledId: number = 3
        let dependency_filled_data: DependencyData = {
            is_met: false,
            dependency: { CreatedDate: moment(), Id: dependency_filledId, Kind: "Filled", hideIfViolated: false, title: i18next.t('form.dep_filled'), lockSubmissionIfViolated: true },
            dependent_fields: [{ FieldId: f1.field.Id }, { FieldId: f2.field.Id }, { FieldId: f3.field.Id }, { FieldId: f3.field.Id }]
        }
        return dependency_filled_data
    }

    let dependency_filled = mk_dependency_filled()
    let dependency_list: DependencyData[] = [dependency_filled]

    let step_3 = (): StepData => {

        return {
            dependencies: dependency_list,
            fields: field_list,
            step: { Id: 3, CreatedDate: moment(), orderNumber: 3, title: i18next.t('Tab3.Title') },
        }
    }

    return [step_3()]
}